import { StyleSheet } from 'aphrodite';
import { borderOutline, brandPrimary, charmGray, lightGray, titles, white } from '../../../../styles/colors';

export const styleSheet = StyleSheet.create({
	popover: {
		position: 'absolute',
		top: 'calc(100% + 8px)',
		right: 0,
		width: 320,
		backgroundColor: white,
		borderRadius: 10,
		border: `1px solid ${borderOutline}`,
		boxShadow: '0 8px 24px rgba(0, 0, 0, 0.12), 0 2px 8px rgba(0, 0, 0, 0.06)',
		padding: '12px 14px',
		zIndex: 100,
	},
	section: {
		marginBottom: 10,
	},
	sectionTitle: {
		fontSize: 11,
		fontWeight: 600,
		textTransform: 'uppercase',
		letterSpacing: '0.05em',
		color: charmGray,
		margin: '0 0 6px 0',
	},
	itemList: {
		display: 'flex',
		flexDirection: 'column',
		gap: 4,
	},
	row: {
		display: 'flex',
		alignItems: 'center',
		gap: 8,
		padding: '3px 0',
	},
	keysCell: {
		display: 'flex',
		alignItems: 'center',
		gap: 3,
		minWidth: 110,
		flexShrink: 0,
	},
	kbd: {
		display: 'inline-block',
		padding: '2px 6px',
		backgroundColor: lightGray,
		border: '1px solid #d1d5db',
		borderRadius: 4,
		fontSize: 11,
		fontWeight: 600,
		fontFamily: 'monospace',
		color: '#374151',
		boxShadow: '0 1px 0 rgba(0, 0, 0, 0.05)',
		lineHeight: '16px',
	},
	keySep: {
		margin: '0 2px',
		color: charmGray,
		fontSize: 10,
	},
	mouseBadge: {
		display: 'inline-block',
		padding: '2px 7px',
		backgroundColor: 'transparent',
		border: `1px solid ${charmGray}`,
		borderRadius: 10,
		fontSize: 11,
		fontWeight: 500,
		color: titles,
		lineHeight: '16px',
	},
	label: {
		fontSize: 12,
		color: '#4b5563',
		whiteSpace: 'nowrap',
		overflow: 'hidden',
		textOverflow: 'ellipsis',
	},
	footerLink: {
		display: 'flex',
		alignItems: 'center',
		gap: 4,
		width: '100%',
		padding: '8px 4px 2px',
		marginTop: 4,
		borderTop: `1px solid ${lightGray}`,
		border: 'none',
		borderTopWidth: 1,
		borderTopStyle: 'solid',
		borderTopColor: borderOutline,
		background: 'none',
		fontSize: 12,
		color: brandPrimary,
		cursor: 'pointer',
		fontWeight: 500,
		':hover': {
			textDecoration: 'underline',
		},
	},
});
